// MyNavBar.js
import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import HomeIcon from '@mui/icons-material/Home';
import { Link, useLocation } from 'react-router-dom';
import './MyNavBar.css';

const MyNavBar = () => {
    const location = useLocation();

    return (
        <Navbar 
            bg="light" 
            expand="lg" 
            data-bs-theme="light" 
            style={{ 
                backgroundColor: "#FFFFFF",
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
        >
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <HomeIcon fontSize="large" style={{ marginRight: '8px' }} />
                    Cognitive Reframing
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link 
                            as={Link} to="/about" 
                            className="nav-link-hover"
                            active={location.pathname === '/about'}
                        >
                            About
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MyNavBar;
